"use client";

import { MediaWorkspace } from "../_components/MediaWorkspace";
import { extractAudioOperation } from "../_operations/extractAudio";

export function ExtractAudioContent() {
  return <MediaWorkspace operation={extractAudioOperation} />;
}
